module.exports = __webpack_public_path__ + "img/1280x720-Party.bc3ba892.jpg";